export const selectProvider = (state) => state.provider.currentProvider;
export const selectProviderLocales = (state) => state.provider.locales;
export const selectProviderId = (state) => state.provider.id;
export const selectProviderLoading = (state) => state.provider.isLoading;
export const selectProviderIsError = (state) => state.provider.isError;
export const selectProviderError = (state) => state.provider.error;